import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { BroadcasterService } from 'src/app/shared/services/broadcaster.service';

export type BrandColorKey = 'baseColor' | 'accentColor';

/**
 * Holds the colors being edited on the Branding page. Changes stay local to
 * the page; nothing is written to the company settings from here.
 */
@Injectable()
export class BrandColorsService {
  private companyStateService = inject(CompanyStateService);
  private broadcaster = inject(BroadcasterService);

  readonly baseColor = signal('');
  readonly accentColor = signal('');

  constructor() {
    const subscription = this.broadcaster.on(
      'risevision.company.selectedCompanyChanged',
      () => this.load(),
    );
    inject(DestroyRef).onDestroy(() => subscription.unsubscribe());

    this.load();
  }

  load(): void {
    const settings =
      this.companyStateService.getCopyOfSelectedCompany()?.settings || {};

    this.baseColor.set(settings.brandingBaseColor || '');
    this.accentColor.set(settings.brandingAccentColor || '');
  }

  setColor(key: BrandColorKey, color: string): void {
    this[key].set(color || '');
  }
}
